import React, { useEffect,  useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';

import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { PageMenuElement } from '../elements/page_menu.js';
import { PRCDropDown } from '../controls/prcdropdown.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export function ReportVisitsByDateForm() {
    const [pageData, setPageData] = useState(new Date());
    const [reportData, setReportData] = useState([]);
    const[visitDate, setVisitDate] = useState();    
    const[memberCount, setMemberCount] = useState(0);
    const navigate = useNavigate();
    
    let first_render = useRef(true);

    const { MakeCall } = useAPICall();

    useEffect(() => {
      setVisitDate(new Date());
    },[setVisitDate]);

   
    const handleReportDataFetch = (data) => {        
        
       setReportData(data.components['report_data']);
       setMemberCount(data.components['member_count']);
    }
  
    function handleNav(destination, state) {
        navigate(destination, state);
    }
   


   function handleGenerateReport()
   {
      MakeCall('reports/getmembervisitsbydatereportdata', "{ \"token\" : \"" + sessionStorage.getItem("Token") + 
         "\", \"visit_date\" : \"" + visitDate.toLocaleDateString('en-GB',  {year: 'numeric', month: 'long', day: 'numeric'}) +  "\"}", handleReportDataFetch, true);
   }

    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/AdminReports");
                break;
           
            default:
                break;
        }
    }
    function handleShowMember(id) {
        navigate("/ViewMember", { state: { memberID: id } });
    }

    return (

        <div>

            {SecurityElement(pageData)}
            {MenuForm()}
            
            <div className="contentdiv">
            {PageMenuElement("Reports", [{ "name": "Back", "onclick": "goback" }], onPageMenuClick)}
              
                <div className='formbox'>
                    <div className='formtitle'>Member Visit Report</div>
                    <div className='formrow' key='description' style={{"paddingBottom":"25px"}}>
                       This report shows visits for all members on the specified date.                                    
                    </div>                    
                    <div className='formrow' key='visits' style={{"paddingBottom":"25px"}}>
                        <div className="gridcell" style={{"width" : "20%"}}> Select the visit date</div>
                        <div className="gridcell">{<DatePicker
                                showIcon
                                selected={visitDate}                                
                                onChange={(date) => setVisitDate(date)}
                                name="visitDate"
                                dateFormat="dd/MM/yyyy" />}
                                </div>
                    </div>
                    <div className='formrow' key='generate' style={{"paddingBottom":"25px"}}>
                        <button type="button" className='prcbtn' onClick={handleGenerateReport}>Generate</button>
                    </div>
                    {<div>Member Count : {memberCount}</div>}
                    <div className='gridrow' key="headers" style={{"paddingTop" : "10px", "paddingBottom" : "10px", "fontWeight" : "bold"}}>

                    <div className='gridcell' style={{"justifyContent" : "left", "width":"15%"}}>Mem #</div>   
                    <div className='gridcell' style={{"justifyContent" : "left", "width":"50%"}}>Name</div>                                           
                    <div className='gridcell' style={{"justifyContent" : "left", "width":"100%"}}>Email</div>   
                    </div>
                    {reportData.map((member) => (
                            <div className='gridrow' key={member.idpeveril_member} style={{"paddingTop" : "10px", "paddingBottom" : "10px"}} onClick={() => { handleShowMember(member.idpeveril_member) }} id={member.idpeveril_member}>                                                            
                            <div className='gridcell' style={{"justifyContent" : "left", "width":"15%"}}>{member.membership_number}</div>   
                            <div className='gridcell' style={{"justifyContent" : "left", "width":"50%"}}>{member.forename + " " + member.surname}</div>                                                                                                                                                                                                                                                                        
                            <div className='gridcell' style={{"justifyContent" : "left", "width":"100%"}}>{member.email}</div>                                 
                        </div>                                                                        
                        ))}
                    
                </div>

           
            </div>
        </div>


    );
}
